var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSendMessage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8045 0.757998L7.64151 9.92099M0.803477 6.57591L16.5339 0.622322C16.5907 0.600618 16.6525 0.595809 16.7119 0.608477C16.7713 0.621145 16.8258 0.650748 16.8688 0.69371C16.9118 0.736671 16.9414 0.791153 16.954 0.850574C16.9667 0.909996 16.9619 0.971814 16.9402 1.02856L10.9866 16.759C10.9629 16.8188 10.9215 16.8698 10.8679 16.9053C10.8144 16.9408 10.7512 16.9591 10.687 16.9576C10.6227 16.9562 10.5605 16.9351 10.5086 16.8972C10.4567 16.8593 10.4176 16.8064 10.3967 16.7457L7.74612 10.214C7.71521 10.1214 7.66321 10.0373 7.5942 9.9683C7.5252 9.89929 7.44109 9.84729 7.34853 9.81638L0.816848 7.16816C0.755316 7.14769 0.701614 7.1087 0.663091 7.05654C0.624568 7.00437 0.603106 6.94157 0.601643 6.87674C0.600179 6.81191 0.618785 6.74821 0.654915 6.69436C0.691044 6.64051 0.742932 6.59914 0.803477 6.57591Z",
    stroke: "#FFF057",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendMessage);
export default __webpack_public_path__ + "static/media/send-message.cd33399368d4a808f7b162a9a7ce68ac.svg";
export { ForwardRef as ReactComponent };